module.exports = __webpack_public_path__ + "static/media/interior6.7fbdf631.png";